import { takeLatest } from 'redux-saga/effects';
import * as types from './reducer';
import {getProTipsSaga} from "./handler";

export default function* watchProTips() {
    yield takeLatest(types.GET_PRO_TIPS, getProTipsSaga);
}
